import markerHighConfidence from "./marker-high-confidence.png";
import markerMediumConfidence from "./marker-middle-confidence.png";
import markerLowConfidence from "./marker-low-confidence.png";
import markerNeverUse from "./marker-never-use.png";

export const markerHighConfidenceIcon = markerHighConfidence;
export const markerMediumConfidenceIcon = markerMediumConfidence;
export const markerLowConfidenceIcon = markerLowConfidence;
export const markerNeverUseIcon = markerNeverUse;
